export default function Intro() {
    return(
        <>
        <h1 className="title">Intro</h1>
        <div className="video-container"><iframe width="560" height="315" src="https://www.youtube.com/embed/7yBPI8aZNPg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
        </>
        );
}